if (window.innerWidth <= 767) {
    var timeout = null;
    
    window.addEventListener('scroll', () => {
        $('[data-js-product-add-to-cart]').addClass('disable');

        if(timeout) clearTimeout(timeout);
        
        timeout = setTimeout(function(){ 
            $('[data-js-product-add-to-cart]').removeClass('disable');
        }, 250);
    })
}